
(function () {
  if (customElements.get('search-box-advanced')) return;

  const cache = new Map();

  const MIN_TERM_LENGTH = 3;

  const SEARCH_FIELDS = [
    'author',
    'body',
    'product_type',
    'tag',
    'title',
    'variants.barcode',
    'variants.sku',
    'variants.title',
    'vendor',
  ].join(',');

  customElements.define(
    'search-box-advanced',
    class SearchBoxAdvanced extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        if (!this.input) return;

        this.results = this.querySelector('[data-search-results]');
        this.clearButton = this.querySelector('[data-search-clear]');
        this.predictiveUrl = this.dataset.predictiveUrl || '/search/suggest';
        this.debounceTimer = null;
        this.fetchController = null;
        this.teardown = new AbortController();
        const signal = this.teardown.signal;

        this.syncClearButton();

        this.input.addEventListener('input', () => {
          if (this.debounceTimer) clearTimeout(this.debounceTimer);
          this.input.setCustomValidity('');
          this.syncClearButton();
          if (!this.results) return;

          const term = this.input.value.trim();
          if (term.length < MIN_TERM_LENGTH) {
            this.hideResults();
            return;
          }

          this.debounceTimer = setTimeout(() => this.fetchResults(term), 250);
        }, { signal });

        const form = this.querySelector('form');
        if (form) {
          form.addEventListener('submit', (event) => {
            if (this.input.value.trim().length >= MIN_TERM_LENGTH) return;
            event.preventDefault();
            this.input.setCustomValidity(
              'Saisissez au moins ' + MIN_TERM_LENGTH + ' caractères pour lancer la recherche.'
            );
            this.input.reportValidity();
          }, { signal });
        }

        if (this.clearButton) {
          this.clearButton.addEventListener('click', () => {
            this.input.value = '';
            this.input.setCustomValidity('');
            this.syncClearButton();
            this.hideResults();
            this.input.focus();
          }, { signal });
        }

        if (!this.results) return;

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.setResultsVisible(false);
        }, { signal });

        this.input.addEventListener('focus', () => {
          if (this.results.innerHTML !== '') this.setResultsVisible(true);
        }, { signal });

        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.setResultsVisible(false);
        }, { signal });
      }

      disconnectedCallback() {
        if (this.teardown) this.teardown.abort();
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        if (this.fetchController) this.fetchController.abort();
      }

      syncClearButton() {
        if (!this.clearButton) return;
        this.clearButton.toggleAttribute('hidden', this.input.value === '');
      }

      setResultsVisible(visible) {
        if (!this.results) return;
        const changed = this.results.hasAttribute('hidden') === !!visible;
        this.results.toggleAttribute('hidden', !visible);
        if (changed) {
          this.dispatchEvent(new CustomEvent('search-box:toggle', {
            bubbles: true,
            composed: true,
            detail: { visible: !!visible },
          }));
        }
      }

      hideResults() {
        if (!this.results) return;
        this.setResultsVisible(false);
        this.results.innerHTML = '';
      }

      showResults(html) {
        this.results.innerHTML = html;
        this.setResultsVisible(true);
      }

      fetchResults(term) {
        if (cache.has(term)) {
          if (this.input.value.trim() === term) this.showResults(cache.get(term));
          return;
        }

        if (this.fetchController) this.fetchController.abort();
        this.fetchController = new AbortController();

        const url = this.predictiveUrl +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product' +
          '&resources[limit]=8' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=' + SEARCH_FIELDS +
          '&section_id=predictive-search-advanced';

        fetch(url, { signal: this.fetchController.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Réponse ' + response.status);
            return response.text();
          })
          .then((text) => {
            const fragment = new DOMParser().parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            if (!fragment) throw new Error('Section absente de la réponse');

            cache.set(term, fragment.innerHTML);
            if (this.input.value.trim() === term) this.showResults(fragment.innerHTML);
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            this.hideResults();
            console.warn('Recherche prédictive indisponible :', error.message);
          });
      }
    }
  );
})();
